/* Product gallery auto-cycle.

   Igor: "images should cycle automatically every few seconds".

   Deliberately drives the theme's OWN thumbnail buttons rather than
   manipulating slides directly. Clicking a thumbnail is the path the theme
   already supports — it handles the active state, the variant/colour filtering
   and the zoom target. Reimplementing that would drift from the theme the first
   time it updates.

   It stops permanently the moment a visitor touches the gallery. Someone who
   has clicked a thumbnail is looking at that image on purpose, and moving it
   under them is worse than not cycling at all. It also pauses while the pointer
   is over the gallery, while the tab is hidden, and it never runs for reduced
   motion. */
(function () {
  'use strict';

  var DELAY = 4000;

  function start() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var gallery = document.querySelector('.product__media-wrapper');
    if (!gallery) return;

    // Selectors taken from the RENDERED DOM, not the section source: the
    // Liquid writes .product__thumbnail but the browser sees .thumbnail-list__item
    // wrapping a button.thumbnail. Using the source class matched nothing and the
    // gallery silently never cycled.
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item')
    ).filter(function (t) { return t.offsetParent !== null; });
    if (thumbs.length < 2) return;   // nothing to cycle

    var timer = null;
    var stopped = false;
    var paused = false;

    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        var b = thumbs[i].querySelector('button.thumbnail');
        if ((b && b.getAttribute('aria-current') === 'true') ||
            thumbs[i].classList.contains('is-active') ||
            (b && b.classList.contains('is-active'))) return i;
      }
      return 0;
    }

    // The cycle works by clicking a thumbnail, and that click bubbles to <body>.
    // The theme's drawers (cart, menu, search) close on any body click outside
    // themselves, so a tick while one is open shut it and left the overlay stuck
    // (the live cart bug of 2026-09-26). Never tick while anything is open.
    var OPEN_STATE = /(mini-cart|menu-drawer|menu-mobile|search-modal|quick-view)--(open|opening)/;
    function somethingOpen() {
      if (OPEN_STATE.test(document.body.className)) return true;
      return !!document.querySelector(
        'header details[open], cart-drawer details[open], menu-drawer details[open], ' +
        'details-modal details[open], dialog[open], modal-dialog[open], product-modal[open], ' +
        '.popup--open, .popup.is-open, .hm-size-modal[open]'
      );
    }

    function tick() {
      if (stopped || paused || document.hidden || somethingOpen()) return;
      var next = thumbs[(currentIndex() + 1) % thumbs.length];
      if (!next) return;
      var target = next.querySelector('button.thumbnail') || next.querySelector('a, button') || next;
      target.click();
    }

    function stop() {
      stopped = true;
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Any deliberate interaction ends it for good — but ONLY a real one.
    // event.isTrusted is false for programmatic clicks, and this script clicks
    // thumbnails itself; without the check the very first tick killed the
    // cycle. The theme also activates a thumbnail during init, which did the
    // same thing before the page had even settled.
    function userStop(e) { if (e && e.isTrusted) stop(); }
    gallery.addEventListener('click', userStop, true);
    gallery.addEventListener('keydown', userStop, true);
    gallery.addEventListener('touchstart', userStop, { passive: true, capture: true });

    gallery.addEventListener('mouseenter', function () { paused = true; });
    gallery.addEventListener('mouseleave', function () { paused = false; });

    timer = window.setInterval(tick, DELAY);
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (e) { /* a gallery that does not auto-cycle is fine; a broken one is not */ }
})();
